export default __webpack_public_path__ + "static/media/SourceSansPro-Light.88e269bd.ttf";